import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

interface ReimportConfirmDialogProps {
  open: boolean;
  onKeep: () => void;
  onReplace: () => void;
}

export const ReimportConfirmDialog: React.FC<ReimportConfirmDialogProps> = ({
  open,
  onKeep,
  onReplace,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onKeep}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        Atualizar dados do atendimento?
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Você alterou manualmente os dados importados. O que deseja fazer?
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box>
            <Typography variant="subtitle2" fontWeight={600}>
              Manter minhas alterações
            </Typography>
            <Typography variant="body2" color="text.secondary">
              O texto que você editou será preservado. Nenhum dado será
              substituído.
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" fontWeight={600}>
              Atualizar com dados do atendimento
            </Typography>
            <Typography variant="body2" color="text.secondary">
              A região &quot;Dados do atendimento&quot; será substituída pelos
              registros atuais. Seus complementos e instruções não serão
              alterados.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onKeep}
          variant="outlined"
          sx={{ textTransform: "none", borderRadius: 2 }}
        >
          Manter alterações
        </Button>
        <Button
          onClick={onReplace}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            bgcolor: "#00ae9a",
            "&:hover": { bgcolor: "#009688" },
          }}
        >
          Atualizar dados
        </Button>
      </DialogActions>
    </Dialog>
  );
};
